import { convertTimeToMili } from "../functions";
import moment from "moment";
export function browserInfo() {
  const userAgent = navigator.userAgent;
  let tem =
    userAgent.match(
      /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
    ) || [];
  let arrayBrowser =
    userAgent.match(
      /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
    ) || [];
  if (/trident/i.test(arrayBrowser[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
    return { name: "MSIE", version: tem[1] || "" };
  }
  if (/Edg/i.test(userAgent)) {
    const verOffset = userAgent.indexOf("Edg");
    const version = userAgent.substring(verOffset + 4);
    return { name: "MSIE", version, original_name: "Edge" };
  }
  if (arrayBrowser[1] === "Chrome") {
    tem = userAgent.match(/\bOPR\/(\d+)/);
    if (tem != null) return { name: "Opera", version: tem[1] };
  }
  arrayBrowser = arrayBrowser[2]
    ? [arrayBrowser[1], arrayBrowser[2]]
    : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = userAgent.match(/version\/(\d+)/i)) != null) {
    arrayBrowser.splice(1, 1, tem[1]);
  }
  if (navigator.userAgent.match('CriOS')) {
    arrayBrowser[0] = 'Chrome';
  }
  return { name: arrayBrowser[0], version: arrayBrowser[1] };
}

export function isSupportedBrowser() {
  return ["Chrome"].includes(browserInfo().name);
}

export function aSync (max_seconds, fnAsync, callback) {
  let cond_stop = false;
  let is_func = false;
  let time_s = (new Date).getTime();
  let time_e = 0;
  let run_seconds = 0;

  if (typeof fnAsync == 'function') is_func = true;
  requestAnimationFrame(runActions);

  function runActions() {
    time_e = (new Date).getTime();
    run_seconds = (time_e - time_s) / 1000;

    if (is_func) cond_stop = fnAsync();
    if (run_seconds > max_seconds) cond_stop = true;

    if (cond_stop) {
      if (typeof callback == 'function') callback();
    } else {
      requestAnimationFrame(runActions);
    }
  }
}

export const getTimeRemaining = (endJoinTime: number | string): number =>{
  if(endJoinTime){
    const countDownDate =
      (convertTimeToMili(Number(endJoinTime)) || 1) + 5000;
    const now = moment().utc().valueOf();
    const distance = countDownDate - now;
    return distance
  }

  return 0
  
}

export const getUnstackTimeRemaining= ({status, stakeTime, lockDuration,applicableAt}) =>{

  let endTime = 0
  const countdownEndTime = status === 0 ? lockDuration : applicableAt;
  const joinTime = status === 0 ? stakeTime : 0;
  if(!joinTime){
      endTime = (convertTimeToMili(Number(countdownEndTime)) || 1) + 5000
  }else{
      endTime = (convertTimeToMili(Number(joinTime)) || 1) + Number(countdownEndTime || 0) * 1000 + 5000;
  }
  const now = moment().utc().valueOf();
  const distance = endTime - now 

  return distance || 0
}